import React from 'react';
import PropTypes from 'prop-types';

const RadioButtons = props => (
  <div className={`ds-radio-buttons ${props.className}`}>
    {
      props.options.map((option, idx) => (
        <label
          className="ds-radio-button-label"
          htmlFor={`${props.id}${idx}`}
          key={option.value}
        >
          <input
            className="radio inline"
            defaultChecked={option.defaultChecked}
            id={`${props.id}${idx}`}
            name={props.id}
            onChange={props.onChange}
            type="radio"
            value={option.value}
          />
          <span className="ds-radio-button-toggle" />
          <div className="ds-radio-button-child-wrapper">
            <span className="ds-radio-button-option-text">
              {option.text}
            </span>
            {option.children}
          </div>
        </label>
      ))
    }
  </div>
);

RadioButtons.defaultProps = {
  className: '',
};

RadioButtons.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.node,
      defaultChecked: PropTypes.bool,
      text: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
};

export default RadioButtons;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/RadioButtons/RadioButtons.jsx